import type { TPageTranslations } from '@crehana/i18n';

import { PAGE_KEY } from './constants';
import type { TKeys } from './types';

export const pt: TPageTranslations<TKeys, typeof PAGE_KEY> = {
  [PAGE_KEY]: {
    SEO_PAGE_TITLE: 'Cálculo de horas | Assistência | Crehana',
    SEO_PAGE_DESCRIPTION:
      'Visualize o cálculo de horas extras e horas de atraso dos registros de assistência.',
    BREADCRUMB_HOME: 'Início',
    BREADCRUMB_ATTENDANCE: 'Assistência',
    BREADCRUMB_HOURS_CALCULATION: 'Cálculo de horas',
    PAGE_TITLE: 'Cálculo de horas',
    PAGE_DESCRIPTION:
      'Visualize o cálculo de horas extras e horas de atraso dos registros de assistência dos seus colaboradores',
    CTA_DOWNLOAD_REPORT: 'Baixar relatório',
    DOWNLOAD_COMING_SOON: 'Disponível em breve',
    FILTER_PERIOD_LABEL: 'Período:',
    FILTER_DATE_SEPARATOR: 'até',
    FILTER_BUTTON: 'Filtrar',
    CARD_TOTAL_COLLABORATORS: 'Total colaboradores',
    CARD_TOTAL_COLLABORATORS_SUB: 'Com registros no período',
    CARD_OVERTIME_HOURS: 'Horas extras acumuladas',
    CARD_LATE_HOURS: 'Horas de atraso',
    CARD_TEAM_TOTAL: 'Total da equipe',
    TABLE_TITLE: 'Resumo por colaborador',
    SEARCH_PLACEHOLDER: 'Buscar colaborador...',
    COLUMN_COLLABORATOR: 'Colaborador',
    COLUMN_SHIFT: 'Turno atribuído',
    COLUMN_WORKED_HOURS: 'Horas trabalhadas',
    COLUMN_OVERTIME: 'Horas extras',
    COLUMN_LATE_HOURS: 'Horas de atraso',
    DAILY_BREAKDOWN_TITLE: 'Detalhamento diário',
    DETAIL_COL_DATE: 'Dia',
    DETAIL_COL_PLANNED_HOURS: 'Horas planejadas',
    DETAIL_COL_WORKED_HOURS: 'Horas trabalhadas',
    DETAIL_COL_OVERTIME: 'Horas extras',
    DETAIL_COL_LATE_HOURS: 'Horas de atraso',
    DETAIL_ACTION_REVIEW: 'Revisar',
    EMPTY_NO_DATA: 'Não há registros de presença no período selecionado.',
    EMPTY_NO_DATA_DESCRIPTION:
      'Selecione outro período ou verifique se os colaboradores possuem registros.',
    FILTER_RANGE_DAYS: '({{count}} dias)',

    // table root states messages
    TABLE_STATE_ERROR_TITLE: 'Erro ao carregar os dados',
    TABLE_STATE_ERROR_SUBTITLE:
      'Ocorreu um erro ao carregar a informação. Por favor, tente novamente.',
    TABLE_STATE_ERROR_RETRY: 'Tentar novamente',
    TABLE_STATE_EMPTY_SEARCH_TITLE: 'Nenhum resultado encontrado',
    TABLE_STATE_EMPTY_SEARCH_SUBTITLE:
      'Nenhum registro encontrado que coincida com "{{query}}".',
    TABLE_STATE_EMPTY_NO_DATA_TITLE: 'Nenhum dado disponível',
    TABLE_STATE_EMPTY_NO_DATA_SUBTITLE: 'Nenhum dado disponível',
    TABLE_STATE_EMPTY_NO_DATA_CTA: 'Criar registro',

    // Day records dialog
    RECORDS_DIALOG_TITLE: 'Registros do dia',
    RECORDS_DIALOG_CLOSE: 'Fechar',
    RECORDS_DIALOG_VIEW_ALL: 'Ver todos os registros',
    RECORDS_COL_TIME: 'Hora',
    RECORDS_COL_EVENT: 'Evento',
    RECORDS_COL_STATUS: 'Estado',
    RECORDS_COL_LOCATION: 'Local',
    RECORDS_COL_CLOCK_TYPE: 'Tipo de marcação',
    RECORDS_ESTIMATED: 'Estimada: {{time}}',
    RECORDS_EVENT_ENTRY: 'Entrada',
    RECORDS_EVENT_BREAK_START: 'Início do intervalo',
    RECORDS_EVENT_BREAK_END: 'Fim do intervalo',
    RECORDS_EVENT_EXIT: 'Saída',
    RECORDS_STATUS_ON_TIME: 'No horário',
    RECORDS_STATUS_ACCEPTABLE: 'Aceitável',
    RECORDS_STATUS_LATE_OR_ABSENT: 'Atraso ou falta',
    RECORDS_CLOCK_WEB: 'Web',
    RECORDS_CLOCK_QR_TABLET: 'QR Tablet',
    RECORDS_CLOCK_APP_MOBILE: 'App Móvel',
    RECORDS_CLOCK_BIOMETRIC: 'Biométrico',

    EMPLOYEE_DIALOG_DETAIL_RECORDS_EDIT_RECORD: 'Editar registro',
  },
};
